<div id="map-elevation"
     class="hidden">
</div>
